"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.App = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _logger2 = require("../logger");
var _FormattedMessage = require("./FormattedMessage");
var _OfferHints = require("./OfferHints");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */ const App = (param)=>{
    let { isDoubleCurrency } = param;
    const [isConfirmationOpen, setIsConfirmationOpen] = (0, _react.useState)(false);
    const [notAvailableOfferIds, setNotAvailableOfferIds] = (0, _react.useState)([]);
    const [isOfferHintsModalOpen, setIsOfferHintsModalOpen] = (0, _react.useState)(false);
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const offers = (0, _react.useMemo)(()=>{
        if (!shoppingContext) {
            return [];
        }
        if (notAvailableOfferIds.length !== 0) {
            return shoppingContext.shoppingBag.basketOffers.filter((offer)=>!notAvailableOfferIds.includes(offer.offerId));
        }
        return shoppingContext.shoppingBag.basketOffers;
    }, [
        shoppingContext,
        notAvailableOfferIds
    ]);
    const toggleConfirmationModal = (0, _react.useCallback)((isOpen)=>{
        setIsConfirmationOpen(isOpen);
    }, [
        setIsConfirmationOpen
    ]);
    const anchorPosition = (0, _react.useRef)({
        top: -500,
        left: -500
    });
    (0, _react.useEffect)(()=>{
        anchorPosition.current = {
            left: window.innerWidth / 2,
            top: window.innerHeight / 2
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
            areaName: "".concat(_constants.APP_NAME, "-boundary"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                    namespace: _constants.translationsNamespace,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
                        team: _testidGenerator.Team.Checkout,
                        project: _constants.APP_NAME,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_contexts.CheckoutOfferHintsProvider, {
                            value: {
                                isDoubleCurrency,
                                offersCount: offers.length,
                                setIsOfferHintsModalOpen,
                                setNotAvailableOfferIds,
                                toggleConfirmationModal
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferHints.OfferHints, {
                                    offers: offers,
                                    isOfferHintsModalOpen: isOfferHintsModalOpen
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
                                    disableScrollLock: false,
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Check, {}),
                                    open: isConfirmationOpen,
                                    timeoutMs: 3000,
                                    "aria-label": formatMessage('added'),
                                    onClose: ()=>toggleConfirmationModal(false),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                            id: "added"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
exports.App = App;
